module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/img_example01-aa9fa12c9fb2b228bbe8d13674f6082f.png";